// extracted by mini-css-extract-plugin
export default {"meals":"MealsList_meals__Ft1Bp","meals-appear":"MealsList_meals-appear__Yl7X+","MealsLoading":"MealsList_MealsLoading__En-bq","MealsError":"MealsList_MealsError__55EPZ"};